import { Direction } from '@angular/cdk/bidi';
import { Component, EventEmitter, Injector, Input, Output, ViewEncapsulation } from '@angular/core';
import { LangChangeEvent } from '@ngx-translate/core';
import { Observable, map, startWith, takeUntil } from 'rxjs';
import { ComponentBase } from '../../base';

@Component({
  selector: 'app-questions-container',
  templateUrl: './questions-container.component.html',
  styleUrls: ['./questions-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class QuestionsContainerComponent extends ComponentBase {
  _isOpened = false;
  @Input() set opened(val) {
    this._isOpened = val;
  }

  get opened() {
    return this._isOpened;
  }

  @Output() close = new EventEmitter<void>();

  dir$: Observable<Direction>;

  constructor(public injector: Injector) {
    super(injector);
    this.dir$ = (this.translateService.onLangChange as Observable<LangChangeEvent>).pipe(
      takeUntil(this.destroy$),
      startWith({
        lang: this.translateService.currentLang,
      }),
      map((lang) => (lang.lang == 'ar' ? 'rtl' : 'ltr'))
    );
  }

  onClose() {
    this.close.emit();
    this.opened = false;
  }
}
